export default __webpack_public_path__ + "static/media/hasWifi.03558729.svg";